import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
// import 'moment/locale/uk';
import { Button, Modal } from 'react-bootstrap';

import ModalConfirmation from './modalConfirmation';
import defaultMedicSvg from '../../../../assets/img/next/svg/medic.svg';
import cabinetSvg from '../../../../assets/img/next/svg/cabinet.svg';
import videoSvg from '../../../../assets/img/video-svgrepo-com.svg';
import screeningLogoSmall from '../../../../assets/img/skrinig40_52x48.svg';

export default function Doctor(props) {
  const [open, setOpen] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [iframeHeight, setIframeHeight] = useState(800);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [isExpired, setIsExpired] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const handleOpenPayment = () => setShowPaymentModal(true);
  const handleClosePayment = () => setShowPaymentModal(false);

  const {
    cabinet_num,
    cancelable,
    cancelable_comment,
    cancelAppointment,
    division,
    doctor,
    id,
    institution,
    time_from,
    work_date,
    isPast,
    city,
    is_video_conference,
    uid_video_conference,
    patient,
    start_at,
    speciality,
    deleted,
    order,
    job,
    slot_type,
  } = props;
  
  const onConfirmDelete = (id) => {
    handleClose();
    cancelAppointment(id);
  }; 

  var duration = moment.duration(moment(start_at).diff(moment(new Date()))).asMinutes();
  
  // Check if order is within payment window (30 minutes)
  const isOrderWithinPaymentWindow = () => {
    if (!order || order.payment_status !== 'created') return false;

    const createdAt = moment(order.created_at);
    const now = moment();
    const diffMinutes = now.diff(createdAt, 'minutes');
    
    return diffMinutes < 30;
  };

  // Handle iframe messages for payment modal
  const handleIframeMessage = (event) => {
    try {
      if (order?.payment_link && event.origin === new URL(order.payment_link).origin) {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data && data.height) {
          setIframeHeight(data.height);
        }
        if (data.message === "close-button") {
          handleClosePayment();
          window.location.reload();
        }
        if (data.message === "monopay-link") {
          window.location.href = data.value;
        }
      }
    } catch (e) {
      console.error("Error handling iframe message", e);
    }
  };

  // Add listener for iframe messages when payment modal is open
  React.useEffect(() => {
    if (showPaymentModal) {
      window.addEventListener('message', handleIframeMessage);
    }
    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [showPaymentModal]);

  // Get payment status text
  const getPaymentStatusText = (status) => {
    const statusStyles = {
      'created': { color: '#fff', backgroundColor: '#f39c12', padding: '2px 6px', borderRadius: '4px' }, // Orange for unpaid
      'paid': { color: '#fff', backgroundColor: '#28a745', padding: '2px 6px', borderRadius: '4px' }, // Green for paid
      'processing': { color: '#fff', backgroundColor: '#17a2b8', padding: '2px 6px', borderRadius: '4px' }, // Blue for processing
      'failed': { color: '#fff', backgroundColor: '#dc3545', padding: '2px 6px', borderRadius: '4px' }, // Red for failed
      'reversed': { color: '#fff', backgroundColor: '#6c757d', padding: '2px 6px', borderRadius: '4px' }, // Gray for refunded
      default: { color: '#fff', backgroundColor: '#6c757d', padding: '2px 6px', borderRadius: '4px' }, // Gray for unknown
    };

    const style = statusStyles[status] || statusStyles.default;
    const styleString = Object.entries(style).map(([key, value]) => `${key}:${value}`).join(';');

    let text;
    switch (status) {
      case 'created': text = "Не оплачено"; break;
      case 'paid': text = "Оплачено"; break;
      case 'processing': text = "Обробляється"; break;
      case 'failed': text = "Не вдалось оплатити"; break;
      case 'reversed': text = "Повернуто"; break;
      default: text = "Невідомий статус"; break;
    }

    return <span style={style}>{text}</span>;
  };

  // Payment countdown timer
  useEffect(() => {
    if (order && order.payment_status === 'created') {
      const createdAt = new Date(order.created_at);
      const expiryTime = new Date(createdAt.getTime() + 30 * 60 * 1000); // 30 minutes from creation
      
      let timer; // Declare timer variable in the outer scope
      
      const updateCountdown = () => {
        const now = new Date();
        const diff = Math.max(0, Math.floor((expiryTime - now) / 1000)); // difference in seconds
        
        if (diff <= 0) {
          setRemainingMinutes(0);
          setRemainingSeconds(0);
          setIsExpired(true); // Set expiration flag
          clearInterval(timer);
        } else {
          setRemainingMinutes(Math.floor(diff / 60));
          setRemainingSeconds(diff % 60);
        }
      };
      
      // Initial update
      updateCountdown();
      
      // Update every second
      timer = setInterval(updateCountdown, 1000);
      
      return () => {
        clearInterval(timer);
      };
    }
  }, [order]);

  const doctorUrl = (() => {
    const params = new URLSearchParams();
    if (job?.id) params.set('job_id', job.id);
    if (slot_type === 'screening_40_plus') params.set('screening_40_plus', 'true');
    const qs = params.toString();
    return `/city/${city?.id}/doctors/${doctor.id}${qs ? `?${qs}` : ''}`;
  })();

  return (
    <div className={`streaming-records-item ${deleted === true ? 'canceled-appointment' : ''}`}>
      <ModalConfirmation isOpen={open} onClose={handleClose} onConfirm={onConfirmDelete} id={id} />
      <div className="streaming-records-item__information">
        <div className="streaming-records-item__user">
          <NavLink
            to={doctorUrl}
            className="streaming-records-item__user-icon"
            style={{ backgroundImage: `url(${doctor.is_virtual ? cabinetSvg : slot_type === 'screening_40_plus' ? screeningLogoSmall : (doctor.photo ?? defaultMedicSvg)})` }}
          />
          <div className="streaming-records-item__user-about">
            <NavLink 
              to={doctorUrl}
              className="streaming-records-item__user-title"
            >
              <div className="streaming-records-item__user-title">
                {doctor.is_virtual
                  ? job?.cabinet_name
                    ? job.cabinet_name
                    : job?.cabinet_num
                      ? `Кабінет №${job.cabinet_num}`
                      : 'Кабінет'
                  : slot_type === 'screening_40_plus' ? 'Кабінет скринінгу' : doctor.full_name}
              </div>
            </NavLink>

            {slot_type !== 'screening_40_plus' && (
              <div className="streaming-records-item__user-description">
                {speciality?.name}
              </div>
            )}
          {slot_type === 'paid' && (
              <div className="streaming-records-item__address-list-item-title">
                <span style={{color: '#fff', backgroundColor: '#b8a817', padding: '2px 6px', borderRadius: '4px', fontSize: '12px'}}>Платні послуги</span>
              </div>
            )}

            {slot_type === 'screening_40_plus' && (
                <div className="streaming-records-item__address-list-item-title">
                  <span style={{color: '#fff', backgroundColor: '#17a2b8', padding: '2px 6px', borderRadius: '4px', fontSize: '12px'}}>Скринінг здоров'я 40+</span>
                </div>
            )}
          </div>
        </div>
        <div className="streaming-records-item__address">
          <ul className="streaming-records-item__address-list">

            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Адреса</div>
              <div className="streaming-records-item__address-list-item-description">
                {job?.division?.address?.display_text || division?.address?.display_text || '-'}
              </div>
            </li>
            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Кабінет</div>
              <div className="streaming-records-item__address-list-item-description">
                <strong>{cabinet_num || '-'}</strong>
              </div>
            </li>
            <li className="streaming-records-item__address-list-item">
              <div className="streaming-records-item__address-list-item-title">Заклад</div>
              <div className="streaming-records-item__address-list-item-description">
                <NavLink to={`/city/${city?.id}/hospitals/${institution?.id}?division_id=${division?.id}`}>
                  {division?.full_name}
                </NavLink>
              </div>
            </li>
            {!!division?.contacts?.length && division.contacts.find(({ type }) => type === 'phone') && (
              <li className="streaming-records-item__address-list-item">
                <div className="streaming-records-item__address-list-item-title">Телефон реєстратури</div>
                <div className="streaming-records-item__address-list-item-description">
                  {division.contacts.reduce(
                    (acc, contact) =>
                      contact.type === 'phone'
                        ? `${acc.length ? `${acc}, ${contact.value}` : `${contact.value}`}`
                        : acc,
                    '',
                  )}
                </div>
              </li>
            )}
            
            {!patient && (
              <li className="streaming-records-item__address-list-item">
                <div className="streaming-records-item__address-list-item-title">Пацієнт</div>
                <div className="streaming-records-item__address-list-item-description">
                  {props.data.json_data?.patient_last_name || '-'} {props.data.json_data?.patient_name || '-'}
                </div>
              </li>
            )}

            {props.data?.ehealth_service_request_number && (
              <li className="streaming-records-item__address-list-item">
                <div className="streaming-records-item__address-list-item-title">Направлення</div>
                <div className="streaming-records-item__address-list-item-description">
                  <NavLink to={`/office/service-requests?page=1&number=${props.data.ehealth_service_request_number}`}>
                    {props.data.ehealth_service_request_number}
                  </NavLink>
                </div>
              </li>
            )}
            
            {/* Order information section */}
            {order?.number && (
              <>
                <li className="streaming-records-item__address-list-item">
                  <div className="streaming-records-item__address-list-item-title">Номер замовлення</div>
                  <div className="streaming-records-item__address-list-item-description">
                    {order.number}
                  </div>
                </li>
                <li className="streaming-records-item__address-list-item">
                  <div className="streaming-records-item__address-list-item-title">Платна послуга</div>
                  <div className="streaming-records-item__address-list-item-description">
                    {order.medical_service_title}
                  </div>
                </li>
                <li className="streaming-records-item__address-list-item">
                  <div className="streaming-records-item__address-list-item-title">Вартість</div>
                  <div className="streaming-records-item__address-list-item-description">
                    {order.order_price} грн
                  </div>
                </li>
                <li className="streaming-records-item__address-list-item">
                  <div className="streaming-records-item__address-list-item-title">Статус оплати</div>
                  <div className="streaming-records-item__address-list-item-description">
                    {getPaymentStatusText(order.payment_status)}
                    
                    {/* Payment countdown timer or expired message */}
                    {deleted === false && !isPast && order.payment_status === 'created' && (
                      isExpired ? (
                        <div className="payment-expired mt-2">
                          <div className="payment-expired-message">
                            Нажаль час резервування сплив, запис на прийом скасовано.
                          </div>
                        </div>
                      ) : (
                        isOrderWithinPaymentWindow() && (
                          <div className="payment-countdown mt-2">
                            <div className="payment-countdown-label">Лишилось часу бронювання:</div>
                            <div className="payment-countdown-timer">
                              {remainingMinutes}:{remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}
                            </div>
                       
                            <div className="streaming-records-item__address-list-item-description mt-2 payment-btn">
                              <Button 
                                variant="success" 
                                onClick={handleOpenPayment}
                                style={{ margin: '0' }}
                              >
                                Оплатити онлайн
                              </Button>
                            </div>
                          </div>
                        )
                      )
                    )}
                  </div>
                </li>
              </>
            )}
          </ul>
        </div>
        
        {/* Online video consultation section */}
        {is_video_conference === 1 && (duration <= 10 && duration >= -15) && (
            <div className="text-center">
              <a className="streaming-records-item__period-action btn btn-primary" href={'https://'+(process.env.REACT_APP_ENV.toLowerCase() === 'production' ? 'ehealth' : 'preprod')+'.ciet-holding.com/video/?user_name=' + encodeURIComponent(patient.full_name) + '&meeting_id=' + uid_video_conference } target="_blank" rel="noopener noreferrer" style={{'color': '#fff'}}><img src={videoSvg} width={25} alt="video" style={{'margin-right': '10px'}}/> Долучитись до онлайн телемедичного прийому</a>
            </div>
        )}
        {is_video_conference === 1 && !isPast && duration > 10 && (
            <div className="text-center">
              <p>
                Посилання на застріч буде тут за 10 хв до її початку. 
              </p>
              <p>
                <strong>Початок зустрічі о {moment(start_at).format('HH:mm, DD.MM.YYYY')}.</strong>
              </p>
            </div>
        )}
      </div>

      <div className="streaming-records-item__period">
        <div className="streaming-records-item__period-date">
          {is_video_conference === 1 && (
              <p>Онлайн прийом</p>
          )}
          <strong>{time_from}</strong>
          {moment(work_date).format('DD.MM.YYYY')}
        </div>
        {!isPast && !deleted && (
          <Button
            className="streaming-records-item__period-action"
            onClick={handleOpen}
            disabled={!cancelable}
            title={cancelable_comment}
          >
            <i className="fas fa-ban" />
            Скасувати прийом
          </Button>
        )}
      </div>

      {deleted === true && (
        <div className="canceled-appointment-overlay">
          <div className="canceled-appointment-badge">
            <div className="canceled-appointment-badge__text">
              <i className="fas fa-ban" />
              Запис скасовано
            </div>
            <NavLink to={doctorUrl} className="canceled-appointment-badge__repeat-link">
               <i className="fas fa-redo-alt" />
              Записатись повторно
            </NavLink>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      <Modal 
        show={showPaymentModal} 
        onHide={handleClosePayment} 
        size="lg" 
        centered
        className="payment-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Оплата послуги</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isExpired ? (
            <div className="payment-expired-modal">
              <div className="payment-expired-message">
                Нажаль час резервування сплив, ваш запис на прийом скасовано.
              </div>
              <div className="text-center mt-4">
                <Button variant="secondary" onClick={handleClosePayment}>
                  Закрити
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className="payment-modal-info mb-4">
                <p>Номер замовлення: <strong>{order?.number}</strong></p>
                <p>Назва мед.послуги: <strong>{order?.medical_service_title}</strong></p>
                {order?.medical_service_price !== order?.order_price && (
                  <>
                  <p>Вартість послуги: <strong>{order?.medical_service_price} грн</strong></p>
                  <p>Сервісний збір: <strong>{new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(order?.order_price - order?.medical_service_price)} грн.</strong></p>
                  </>
                )}
                <p>Сума до оплати: <strong>{order?.order_price} грн</strong></p>
              </div>
              <div className="iframe-container">
                {order?.payment_link && (
                  <iframe
                    id="payFrame"
                    title="monopay"
                    width="100%"
                    height={iframeHeight}
                    src={order.payment_link}
                    allow="payment *"
                    style={{
                      borderRadius: "24px", 
                      border: "none", 
                      overflow: "hidden",
                      transition: "height 0.3s ease"
                    }}
                  />
                )}
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
